import styled from 'styled-components';

const Container = styled.div`
  margin: 0 auto;
  width: 75%;
  @media(min-width: 1024px) {
    width: 88%;
  }
  @media(min-width: 1440px) {
    width: 65%;
  }
`;

export default Container;



// WEBPACK FOOTER //
// ./src/elements/Container.js